export default {
  regionalRiskAssessment: {
    eudrDueDiligence: "EUDR Due Diligence",
    title: "Regional Risk Assessment",
    titleTT: "Country benchmarking in EUDR regional risk assessment",
    details: "Details",
    detailsTT: "Expand to view detailed criteria and references related to high-risk classification, focusing on deforestation, indigenous rights, corruption, and human rights issues",
    createNewCountryReport: "Create New Country Report",
    updateCountryReport: "Update Country Report",
    duplicateCountryReport: "Duplicate Country Report",
    search: "Search",
    country: "Country",
    dateCreated: "Date Created",
    edit: "Edit",
    delete: "Delete",
    duplicate: "Duplicate",
    actions: "Actions",
    submit: "Submit",
    save: "Save",
    cancel: "Cancel",
    selectCountry: "Select Country",
    riskAssessmentCriteria: "Risk Assessment Criteria",
    riskLevel: "Risk Level",
    unassigned: "Unassigned",
    standard: "Standard",
    standardToHigh: "Standard to High",
    high: "High",
    reportDetails: "Report Details",
    select: "Select", 
    requiredFields: "This field is required",
    pleaseFillRequiredFields: "Please fill in all required fields",
    createCuccess: "Regional risk assessment created successfully",
    updateSuccess: "Regional risk assessment updated successfully",
    createError: "Error creating regional risk assessment",
    updateError: "Error updating regional risk assessment",
    deleteSuccess: "Regional risk assessment deleted successfully",
    duplicateSuccess: "Regional risk assessment duplicated successfully",
    deleteRegionalRisk: "Delete Regional Risk Assessment",
    confirmDelete: "Are you sure you want to delete this regional risk assessment?",
    confirm: "Confirm",
    saveSuccess: "Regional risk assessment saved successfully",
    fetchError: "Error fetching regional risk assessment",
    disregard: "Disregard Segments",
    addRegionalRiskAssessment: "Add Regional Risk Assessment",
    summary: "Summary",
    summaryTT: "This section outlines the risk levels assigned  based on comprehensive data and references.",
    summaryText: "The country risk assessment will classify the farm's country according to the following risk levels (High, Standard and Zero/Negligible) based on verifiable references, information, documents, and data. Results different from “Zero/Negligible” will indicate the need for some risk mitigation action (RMA) to ensure “Zero/Negligible Risk”. The Table 1 shows the overall results of the risk assessment for (country). The full country risk assessment is attached to this document in the Annex III.",
    disregardConfirmTitle:"Disregard Any One or All Segments",
    addConfirmTitle:"Add Any One or All Segments",
    selectSegment:"Select segments to disregard.",
    deselectToAddSegment: "Deselect segments to add.",
    all: "All",
    protectedAreas: "Protected & Indigenous Areas",
    verificaton: "Verification with Brazil Government Database",
    confirmation: "Confirmation",
    confirmationMessage: "Are you sure you want to disregard regional risk assessment? Confirming this action will result in removal of regional risk assessment from due diligence report.",
    noSegmentSelectedMessage: "No segment is selected. Please select a segment to proceed.",
    singleRiskAssessmentCriteriaMessage: "Are you sure you want to add or remove the Regional Risk Assessment Criteria? Confirming this action will update the due diligence report accordingly.",
    singleProtectedAreasMessage: "Are you sure you want to add or remove the Protected and Indigenous Areas? Confirming this action will update the due diligence report accordingly.",
    bothSegmentsMessage: "Are you sure you want to add or remove both the Regional Risk Assessment Criteria and the Protected and Indigenous Areas? Confirming this action will update the due diligence report accordingly.",
    segmentsUpdatedSuccessfully: "Segments updated successfully",
    
  },
};
